var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('el-button',{staticStyle:{"padding":"10px 20px"},attrs:{"type":"primary","icon":"el-icon-download"},on:{"click":_vm.installExcel}},[_vm._v("导出Excel")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }